import { render, staticRenderFns } from "./ConsultarLDI.vue?vue&type=template&id=0306b7a0&scoped=true"
import script from "./ConsultarLDI.vue?vue&type=script&lang=ts"
export * from "./ConsultarLDI.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0306b7a0",
  null
  
)

export default component.exports